import FormattedImage from '../FormattedImage/FormattedImage';

import styles from './AddToAppleWallet.module.css';

function AddToAppleWallet({ addToAppleWallet }) {
  return (
    <button className={styles.walletImageContainer} onClick={() => addToAppleWallet()}>
      <FormattedImage
        path="/assets/wave-grocery/add-apple-wallet.webp"
        alt="Προσθήκη στο apple wallet"
        width={108}
        height={33}
      />
    </button>
  );
}

export default AddToAppleWallet;
